import React, { Component, Fragment } from 'react';
import { Grid } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';

import { ReportGeneration } from 'Common/ObjectHelper';
import { toastError, errorToast } from 'Common/ToastHelper';
import { Filter, Main } from 'Containers/';
import { ChargesAndPrepaymentsReportForm } from './components/ChargesAndPrepaymentsReportForm';
import { ChargesAndPrepaymentsReportFieldEnum as Fields } from 'Common/FieldEnum';
import { defaultDateFormat } from 'Common/GeneralHelper';
import { CHARGES_AND_PREPAYMENTS_REPORT_FORM_NAME } from 'Common/FormEnum';
import {
  getReport,
  clearReport,
  getUsers,
  clearErrors,
} from './state/chargesandprepaymentsreport/actions';
import { LoadingPage } from 'Components/loading/LoadingPage';
import SelectSitesTable from 'Common/SelectSitesTable';
import { TitledCard } from 'Components/';

class ChargesAndPrepaymentsReportContainer extends Component {
  state = {
    selectedSites: [],
  };

  getMainProps = () => {
    const { loading } = this.props;
    return {
      toolbox: {
        formName: CHARGES_AND_PREPAYMENTS_REPORT_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: loading,
          disabled: loading,
        },
        shown: true,
      },
    };
  };

  componentDidUpdate(prevProps, prevState) {
    const { report } = this.props;
    if (report && prevState !== report) {
      ReportGeneration(report, 'Charges & Prepayments Report');
      this.props.clearReport();
    }

    if (errorToast(this.props, prevProps, 'error')) {
      this.props.clearErrors();
    }
  }

  componentWillMount() {
    this.props.getUsers();
  }

  handleSubmit = formValues => {
    let values = { ...formValues };
    values.User = values.User === -1 ? null : values.User;

    let errors = [];
    this.validateStatuses(errors);
    this.validateSites(errors);

    if (errors.length) {
      errors.forEach(error => toastError(error));
      return;
    }

    this.props.getReport({
      ...values,
      [Fields.Statuses]: this.props.statuses,
      [Fields.Sites]: this.state.selectedSites,
    });
  };

  validateStatuses(errors) {
    if (!this.props.statuses.length) {
      errors.push('A Status must be selected.');
    }
  }
  validateSites(errors) {
    if (!this.state.selectedSites.length) {
      errors.push('A Site must be selected.');
    }
  }

  render() {
    return (
      <Fragment>
        {this.props.loading ? <LoadingPage /> : undefined}
        <Filter title={'Charges & Prepayments Report'} />
        <Main {...this.getMainProps()}>
          <TitledCard title="Report Settings">
            <ChargesAndPrepaymentsReportForm
              onSubmit={this.handleSubmit}
              initialValues={{
                [Fields.User]: -1,
                [Fields.FromDate]: defaultDateFormat(moment()),
                [Fields.ToDate]: defaultDateFormat(moment()),
                [Fields.AdjustmentsOnly]: false,
              }}
              userOptions={this.props.userOptions}
            />
          </TitledCard>
          <TitledCard title="Sites">
            <Grid.Row>
              <Grid.Column>
                <SelectSitesTable
                  onChange={selectedSites => {
                    this.setState({ selectedSites });
                  }}
                />
              </Grid.Column>
            </Grid.Row>
          </TitledCard>
        </Main>
      </Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    userOptions:
      state.ChargesAndPrepaymentsReportState.chargesandprepaymentsreport
        .userOptions,
    statuses:
      state.ChargesAndPrepaymentsReportState.chargesandprepaymentsreport
        .statuses,
    loading:
      state.ChargesAndPrepaymentsReportState.chargesandprepaymentsreport
        .loading,
    report:
      state.ChargesAndPrepaymentsReportState.chargesandprepaymentsreport.report,
    error:
      state.ChargesAndPrepaymentsReportState.chargesandprepaymentsreport.error,
  };
};

export const ChargesAndPrepaymentsReport = withRouter(
  connect(mapStateToProps, {
    getReport,
    clearReport,
    getUsers,
    clearErrors,
  })(ChargesAndPrepaymentsReportContainer)
);



// WEBPACK FOOTER //
// ./src/pages/chargesandprepaymentsreport/ChargesAndPrepaymentsReport.js